// Page_Institution_Facturation.jsx
import React, { useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";
import { BillingsAPI } from "../../../../api/billingsAPI";
import { useAuth } from "../../../../hooks";
import { ListBilling } from "../../../../components/BillingsCmp/ListBillings/ListBilling";
import "./Page_Institution_Facturation.scss";

const billingController = new BillingsAPI();

export function Page_Institution_Facturation() {
  const { accessToken, user } = useAuth();
  const [billings, setBillings] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await billingController.getBillingsByUser(
          accessToken,
          user.user._id,
        );
        setBillings(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [accessToken, user.user._id]);

  if (loading) return <Loader active inline="centered" />;
  if (!billings) return null;

  return (
    <div className="page-institution-facturation">
      <ListBilling billings={billings} showCommission={false} />
      {/* showCommission -> false => NO muestra la columna “Comisión” */}
    </div>
  );
}
